export const IS_LOADING_EMPLOYEE_CALENDAR_EVENTS = 'IS_LOADING_EMPLOYEE_CALENDAR_EVENTS';
export const IS_LOADING_EMPLOYEE_CALENDAR_EVENT = 'IS_LOADING_EMPLOYEE_CALENDAR_EVENT';
export const IS_SAVE_EMPLOYEE_CALENDAR_EVENT = 'IS_SAVE_EMPLOYEE_CALENDAR_EVENT';
export const GET_EMPLOYEE_CALENDAR_EVENTS = 'GET_EMPLOYEE_CALENDAR_EVENTS';
export const GET_EMPLOYEE_CALENDAR_EVENT = 'GET_EMPLOYEE_CALENDAR_EVENT';
export const FAIL_EMPLOYEE_CALENDAR_EVENTS = 'FAIL_EMPLOYEE_CALENDAR_EVENTS';
export const FAIL_EMPLOYEE_CALENDAR_EVENT = 'FAIL_EMPLOYEE_CALENDAR_EVENT';
export const FAIL_SAVE_EMPLOYEE_CALENDAR_EVENT = 'FAIL_SAVE_EMPLOYEE_CALENDAR_EVENT';
